<template>
  <div class="reset-password-container" :class="{
    isMobile: isMobile()
  }">
    <div class="sys-max-width">
      <div class="reset-box">
        <div class="title">手机号找回密码</div>

        <el-form ref="registerForm" :model="registerForm" :rules="registerRules">
          <el-form-item prop="phone">
            <el-input placeholder="请填写手机号" @input="mobileOnlyNumber" v-model.trim="registerForm.phone"></el-input>
          </el-form-item>

          <el-form-item class="img-code-item">
            <el-input
              v-model.trim="imageCheckCode"
              placeholder="请填写图形验证码"
              :validate-event="false"
            />

            <div class="img-box" @click="reGetQrCodeHandle">
              <img class="img-common" :src="qrCodeImgUrl" />
            </div>
          </el-form-item>

          <el-form-item class="code-item" prop="checkCode">
            <el-input
              v-model.trim="registerForm.checkCode"
              @input="codeOnlyNumber"
              placeholder="请填写验证码"
            />

            <el-button type="primary" @click="sendcodeHandle" :disabled="codeDisabled">
              <span v-if="!codeDisabled">发送验证码</span>

              <span v-if="codeDisabled">{{codeTime}}s</span>
            </el-button>

          </el-form-item>

          <el-form-item prop="password">
            <el-input placeholder="设置您的登录密码" type="password" v-model.trim="registerForm.password"></el-input>
          </el-form-item>

          <el-form-item prop="confirmPassword">
            <el-input placeholder="再次输入登录密码" type="password" v-model.trim="registerForm.confirmPassword"></el-input>
          </el-form-item>
            
          <el-form-item>
            <el-button class="submit-btn" :loading="loading" type="primary" @click="userSubmit">提交</el-button>
            <div class="login-tip" @click="$router.push({name: 'login'})">返回登录页</div>
          </el-form-item>

        </el-form>

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { isMobile } from '@/utils/index'
import { resetPasswordFetch, sendCode } from '@/api/login'
import { maxCodeTime } from '@/config/index'
import jsSHA from "jssha"
import imgQrCodeMixins from '@/mixins/imgQrCode'

const checkMobile = (rule, value, callback) => {
  if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
    return callback(new Error('您输入的手机号不合法'))
  }

  callback()
}
const checkCode = (rule, value, callback) => {
  if (!(/^\d{6}$/.test(value))) {
    return callback(new Error('您输入的验证码不合法'))
  }

  callback()
}

export default {
  mixins: [imgQrCodeMixins],

  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.registerForm.confirmPassword !== '') {
          this.$refs.registerForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    
    return {
      // 验证码倒计时
      codeTimer: null,
      codeTime: maxCodeTime,
      codeDisabled: false,

      registerForm: {
        phone: "",
        checkCode: '',
        password: '',
        confirmPassword: ''
      },
      registerRules: {
        phone: [
          { required: true, message: '手机号为必填项', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],

        checkCode: [
          { required: true, message: '验证码为必填项', trigger: 'blur' },
          { validator: checkCode, trigger: 'blur' }
        ],

        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      },

      loading: false
    }
  },
  mounted() {

  },
  methods: {
    isMobile,
    codeOnlyNumber(value) {
      this.registerForm.checkCode = value.replace(/[^\d]/g, ""); 
    },
    mobileOnlyNumber(value) {
      this.registerForm.phone = value.replace(/[^\d]/g, ""); 
    },

    sendcodeHandle() { // 点击发送验证码
      this.$refs['registerForm'].validateField('phone', async errMsg => {
        if (!errMsg) { // 手机号验证成功

          if (!this.imageCheckCode) {
            this.$message.error('请填写图形验证码')
            return
          }

          try {
            this.codeDisabled = true

            await sendCode({
              mobile: this.registerForm.phone,
              code: this.code, // 随机数验证码
              imageCheckCode: this.imageCheckCode
            })

            this.$message.success('发送验证码成功')

            this.codeTimer = setInterval(() => {
              if (this.codeTime === 0) {
                clearInterval(this.codeTimer)

                this.codeTime = maxCodeTime
                this.codeDisabled = false
              } else {
                this.codeTime = this.codeTime - 1
              }
            }, 1000)
          } catch (error) {
            this.codeDisabled = false
          }
        }
      })
    },

    userSubmit() {
      this.$refs['registerForm'].validate(async valid => {
        if (valid) {
          this.loading = true

          // 加密
          const shaObj1 = new jsSHA("SHA-1", "TEXT", { encoding: "UTF8" })
          const shaObj2 = new jsSHA("SHA-1", "TEXT", { encoding: "UTF8" })
          shaObj1.update(this.registerForm.password)
          shaObj2.update(this.registerForm.confirmPassword)

          let params = {
            ...this.registerForm,
            mobile: this.registerForm.phone,
            password: shaObj1.getHash("HEX"),
            confirmPassword: shaObj2.getHash("HEX")
          }

          delete params.phone

          try {
            await resetPasswordFetch(params)

            this.loading = false
            this.$message.success('修改密码成功')
            this.$router.push({
              name: 'login'
            })
          } catch (error) {
            this.loading = false
          }
        } else {
          return false
        }
      })
    },
  },
  created() {

  },
  destroyed() {
    clearInterval(this.codeTimer)
  }
}
</script>

<style lang="scss">
.reset-password-container {
  background: $bg;

  &.isMobile {
    .sys-max-width {
      padding: 1.5rem;

      .reset-box {
        padding: 4rem 1.5rem;
      }
    }
  }

  .code-item {
    margin-bottom: 22px;
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
    }

    .el-button {
      width: 110px;
      margin-left: 10px;
    }
  }

  .img-code-item {
    margin-bottom: 22px;
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
    }

    .img-box {
      cursor: pointer;
      width: 176px;
      height: 40px;
      margin-left: 10px;
      border: 1px solid #F4F7FC;
    }
  }

  .sys-max-width {
    padding: 49px 60px 71px;

    .reset-box {
      background: #FFFFFF;
      box-shadow: 0px 0px 10px 0px rgba(26, 104, 202, 0.1);
      border-radius: 10px;

      padding: 56px 296px 50px;

      .title {
        text-align: center;
        font-size: 20px;
        font-weight: 400;
        color: #596270;
        line-height: 24px;
        margin-bottom: 44px;
      }

      .read-item {
        margin-bottom: 37px;

        .text {
          color: #333;
        }

        .link {
          cursor: pointer;
          color: $primary;
        }

        .check-text {
          margin-left: 11px;
        }

        
      }

      .submit-btn {
        width: 100%;
      }

      .login-tip {
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #596270;
        line-height: 24px;
        margin-top: 29px;
        cursor: pointer;
      }
    }
  }
}
</style>
